var indexOf = [].indexOf;

angular.module('website').controller('website.calendarCtrl', ["$scope", "$stateParams", "$state", "$modal", "$filter", "$compile", "$timeout", "$window", "$location", "$document", "Restangular", "DataService", "CalendarService", "ContrastColor", function($scope, $stateParams, $state, $modal, $filter, $compile, $timeout, $window, $location, $document, Restangular, DataService, CalendarService, ContrastColor) {
  var CalendarData, Classrooms, Website, addCustomButtons, defaultView, domain, onEventSelect, parseIds;
  domain = DataService.domain;
  $scope.instructors = DataService.instructors;
  $scope.eventTypes = DataService.event_types;
  $scope.glossary = DataService.glossary;
  $scope.filtersMultiSelect = DataService.gym_config.website_calendar_filters === 'multi_select';
  $scope.showInstructor = DataService.gym_config.show_instructor_on_website_calendar;
  $scope.showCapacity = DataService.gym_config.show_capacity_on_website_calendar;
  $scope.bookingSuccessGtmId = DataService.gym_config.gtm_code_for_website_booking_success;
  $scope.freeTrialBookingSuccessful = false;
  $scope.pixelId = DataService.gym_config.facebook_pixel_id_for_free_trial_calendar;
  $scope.pixelEvent = DataService.gym_config.facebook_pixel_event_for_free_trial_calendar;
  defaultView = (function() {
    switch (DataService.gym_config.external_calendar_default_view) {
      case 'week':
        return 'agendaWeek';
      case 'daily_agenda':
        return 'basicDay';
      default:
        return 'month';
    }
  })();
  Website = Restangular.all('websites').all(domain);
  Classrooms = Website.all('classrooms');
  CalendarData = Website.all('calendar').all('data');
  parseIds = function(val) {
    if (!val) {
      return [];
    }
    if (Array.isArray(val)) {
      return val.map(function(item) {
        return +item;
      });
    } else {
      return [+val];
    }
  };
  $scope.onBookingSuccess = function(eventParams) {
    $scope.bookingComplete = true;
    return $timeout(function() {
      if (!window.dataLayer) {
        return;
      }
      return window.dataLayer.push(eventParams);
    }, 500);
  };
  onEventSelect = function(event) {
    var bookingModal, calendar;
    calendar = $('#calendar');
    $document.scrollTop(0);
    if (event.cancelled) {
      bookingModal = $modal.open({
        template: require('templates/cancelled_event_modal.html'),
        controller: 'BookingModalCtrl',
        resolve: {
          event: function() {
            return event;
          },
          isFreeTrials: function() {
            return false;
          },
          onBookingSuccess: function() {
            return $scope.onBookingSuccess;
          }
        }
      });
    } else {
      bookingModal = $modal.open({
        template: require('templates/create_booking_modal.html'),
        controller: 'BookingModalCtrl',
        resolve: {
          event: function() {
            return event;
          },
          isFreeTrials: function() {
            return false;
          },
          onBookingSuccess: function() {
            return $scope.onBookingSuccess;
          }
        }
      });
    }
    return bookingModal.result.then(function() {
      if (event.free_class === true) {
        $scope.freeTrialBookingSuccessful = true;
      }
      return calendar.fullCalendar('refetchEvents');
    });
  };
  $scope.locations = [];
  $scope.selectedInstructors = [];
  $scope.selectedInstructors = $scope.instructors.filter(function(type) {
    var id, ids;
    id = type.id.toString();
    ids = $stateParams['instructor_id[]'];
    return id === $stateParams.instructor_id || (ids && indexOf.call(ids, id) >= 0);
  });
  $scope.selectedEventTypes = $scope.eventTypes.filter(function(type) {
    var id, ids;
    id = type.id.toString();
    ids = $stateParams['event_type_id[]'];
    return id === $stateParams.event_type_id || (ids && indexOf.call(ids, id) >= 0);
  });
  Classrooms.getList().then(function(locations) {
    var defaultLocationIds, ref, ref1, ref2, ref3, ref4;
    $scope.locations = locations;
    $scope.locationsDidResolved = true;
    defaultLocationIds = ((ref = parseIds($stateParams.location_id)) != null ? ref.length : void 0) ? parseIds($stateParams.location_id) : ((ref1 = parseIds($stateParams['location_id[]'])) != null ? ref1.length : void 0) ? parseIds($stateParams['location_id[]']) : DataService.gym_config.default_calendar_location_id ? [DataService.gym_config.default_calendar_location_id] : [];
    $scope.selectedLocations = _.filter(locations, function(location) {
      var ref2;
      return ref2 = location.id, indexOf.call(defaultLocationIds, ref2) >= 0;
    });
    if ((ref2 = parseIds($stateParams.ex_location_id)) != null ? ref2.length : void 0) {
      $scope.selectedLocations = _.filter(locations, function(location) {
        var ref3;
        return ref3 = location.id, indexOf.call(parseIds($stateParams.ex_location_id), ref3) < 0;
      });
    } else if ((ref3 = parseIds($stateParams['ex_location_id[]'])) != null ? ref3.length : void 0) {
      $scope.selectedLocations = _.filter(locations, function(location) {
        var ref4;
        return ref4 = location.id, indexOf.call(parseIds($stateParams['ex_location_id[]']), ref4) < 0;
      });
    }
    if ((defaultLocationIds != null ? defaultLocationIds.length : void 0) && !((ref4 = $scope.selectedLocations) != null ? ref4.length : void 0)) {
      $scope.selectedLocations = [locations[0]];
    }
    return $scope.eventSources = [
      {
        events: function(start,
      end,
      callback) {
          var endDate,
      params,
      startDate;
          startDate = moment(start).subtract(1,
      'days').format('X');
          endDate = moment(end).add(1,
      'days').format('X');
          params = {
            'start': startDate,
            'end': endDate,
            'location_id[]': $scope.selectedLocations.map(function(item) {
              return item.id;
            }),
            'instructor_id[]': $scope.selectedInstructors.map(function(item) {
              return item.id;
            }),
            'event_type_id[]': $scope.selectedEventTypes.map(function(item) {
              return item.id;
            }),
            '_': new Date().getTime()
          };
          return CalendarData.getList(params).then(function(data) {
            var items;
            $scope.eventsLoaded = true;
            items = data.plain().map(function(item) {
              var ref5;
              item.isCancelled = !!item.cancelled;
              item.isTitleLong = ((ref5 = item.title) != null ? ref5.length : void 0) > 20;
              item.textColor = ContrastColor.get(item.color);
              return item;
            });
            return callback(items);
          });
        }
      }
    ];
  });
  $scope.onLocationsChange = function(selectedLocations) {
    $scope.selectedLocations = selectedLocations;
    $location.search('location_id', selectedLocations.map(function(item) {
      return item.id;
    }));
    $location.search('ex_location_id', []);
    $location.search('ex_location_id[]', []);
    return $scope.calendarView.calendar.refetchEvents();
  };
  $scope.onInstructorsChange = function(selectedInstructors) {
    $scope.selectedInstructors = selectedInstructors;
    return $scope.calendarView.calendar.refetchEvents();
  };
  $scope.onEventTypesChange = function(selectedEventTypes) {
    $scope.selectedEventTypes = selectedEventTypes;
    $location.search('event_type_id', selectedEventTypes.map(function(item) {
      return item.id;
    }));
    return $scope.calendarView.calendar.refetchEvents();
  };
  $scope.currentView = function() {
    var ref;
    return (ref = $scope.calendarView) != null ? ref.calendar.getView() : void 0;
  };
  $scope.setDailyAgenda = function() {
    return $scope.calendarView.calendar.changeView('basicDay');
  };
  $scope.showWeeklyAgenda = function() {
    var url;
    if ($scope.isIframe()) {
      return $scope.displayWeeklyAgenda = true;
    } else {
      url = `/websites/${domain}/calendar/weekly_agenda`;
      $window.open(url, '_self');
      return true;
    }
  };
  $scope.showFreeTrials = function() {
    var url;
    if ($scope.isIframe()) {
      return $scope.displayFreeTrials = true;
    } else {
      url = `/websites/${domain}/calendar/free_trials`;
      $window.open(url, '_self');
      return true;
    }
  };
  $scope.showCalendar = function() {
    $scope.displayWeeklyAgenda = false;
    return $scope.displayFreeTrials = false;
  };
  addCustomButtons = function() {
    var compiledButtons;
    if (!angular.element('website-calendar-navigation-buttons').length) {
      compiledButtons = $compile('<website-calendar-navigation-buttons/>')($scope);
      return angular.element('.fc-header-left').append(compiledButtons);
    }
  };
  $scope.isIframe = function() {
    return $location.path().indexOf('calendar/iframe') > -1;
  };
  $scope.calendarReady = function() {
    return $scope.locationsDidResolved && $scope.uiConfig;
  };
  return CalendarService.getEvent($stateParams.event_id).then(function(event) {
    var initial, ref, ref1;
    if (event) {
      initial = moment(event.start, 'YYYY/MM/DD HH:mm');
      $scope.initialYear = +initial.format('YYYY');
      $scope.initialMonth = initial.format('M') - 1;
      $scope.initialDay = +initial.format('D');
      onEventSelect(event);
    }
    return $scope.uiConfig = {
      calendar: {
        year: $scope.initialYear,
        month: $scope.initialMonth,
        date: $scope.initialDay,
        editable: false,
        allDayDefault: false,
        allDaySlot: false,
        defaultView: defaultView,
        firstHour: 9,
        firstDay: DataService.calendar_start_wday,
        minTime: ((ref = DataService.gym_config.calendar_display_hours_override) != null ? ref[0] : void 0) || 0,
        maxTime: ((ref1 = DataService.gym_config.calendar_display_hours_override) != null ? ref1[1] : void 0) || 24,
        eventClick: function(event) {
          return onEventSelect(event);
        },
        eventAfterAllRender: function(view) {
          var dropdown, filterElement, ref2;
          $scope.calendarView = view;
          window.calendarView = view;
          addCustomButtons();
          $scope.displayOldEventsHiddenWarning = ((ref2 = window.DATA) != null ? ref2.old_event_display_threshold : void 0) > moment(view.start).format('X');
          $scope.oldEventDisplayThresholdDate = moment(new Date(window.DATA.old_event_display_threshold * 1000)).format('LL');
          filterElement = `<calendar-filters
  locations="locations"
  instructors="instructors"
  event-types="eventTypes"
  selected-locations="selectedLocations"
  selected-instructors="selectedInstructors"
  selected-event-types="selectedEventTypes"
  multi-select="filtersMultiSelect"
  display-old-events-hidden-warning="displayOldEventsHiddenWarning"
  old-event-display-threshold-date="oldEventDisplayThresholdDate"
  on-locations-change="onLocationsChange(locations)"
  on-instructors-change="onInstructorsChange(instructors)"
  on-event-types-change="onEventTypesChange(eventTypes)"
  hide-instructor="!showInstructor"
/>`;
          dropdown = $compile(filterElement)($scope);
          if (!$(".fc-subheader").length) {
            return $(".fc-header").after(dropdown);
          } else {
            return $('.fc-subheader').replaceWith(dropdown);
          }
        },
        dayClick: function(date, allDay, event, sourceView) {
          var calendar;
          calendar = $('#calendar');
          calendar.fullCalendar('changeView', 'agendaDay');
          return calendar.fullCalendar('gotoDate', date);
        },
        header: {
          left: 'agendaDay,agendaWeek,month',
          center: 'title',
          right: 'today prev,next'
        },
        buttonText: {
          month: 'Month',
          agendaDay: 'Day',
          agendaWeek: 'Week'
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd d-MMM',
          day: 'dddd MMM d'
        },
        viewRender: function(view) {
          if (view.name === 'basicDay') {
            return $timeout(function() {
              var ref2;
              if ((view != null ? (ref2 = view.calendar) != null ? ref2.option : void 0 : void 0) != null) {
                return view.calendar.option('aspectRatio', 1.35);
              }
            }, 50);
          }
        },
        eventRender: function(event, element, view) {
          var capacityCell, classroomCancelledClassname, classroomClassname, classroomDividerClassname, classroomHeaderClassname, classroomInstructorClassname, eventContainer, eventTitleElement, eventsHeader, existingTitle, headerTitleClassname, instructorCancelledClassname, instructorCell, titleClassname, titleText, typeCancelledClassname, typeClassname, typeEmptyClassname, typeHeaderClassname, typeInstructorClassname, vacanciesCancelledClassname;
          if (event.isCancelled) {
            $(element).addClass('fc-event--cancelled');
            $(element).css('background-color', '#9E9E9E');
            $(element).css('color', '#FFFFFF');
            $(element).find('.fc-event-skin').css('background-color', '#9E9E9E');
            $(element).find('.fc-event-skin').css('border-color', '#9E9E9E');
            $(element).css('text-decoration', 'line-through');
            $(element).css('text-decoration-skip-ink', 'none');
            if (view.name === 'month') {
              existingTitle = $(element).find('.fc-event-title');
              if (existingTitle.length) {
                existingTitle.addClass('fc-event-title--cancelled');
              }
              $(element).find('.fc-event-time').addClass('fc-event-time--cancelled');
            } else if (view.name === 'agendaWeek') {
              existingTitle = $(element).find('.fc-event-title');
              if (existingTitle.length) {
                existingTitle.addClass('fc-event-title--cancelled');
              }
              $(element).find('.fc-event-time').addClass('fc-event-time--cancelled');
            } else if (view.name === 'agendaDay') {
              if (!event.isTitleLong) {
                $(element).find('.fc-event-inner').append('<span class="fc-event__cancelled-badge fc-event__cancelled-badge--daily">CANCELLED</span>');
              }
              existingTitle = $(element).find('.fc-event-title');
              if (existingTitle.length) {
                existingTitle.addClass('fc-event-title--cancelled');
              }
              $(element).find('.fc-event-time').addClass('fc-event-time--cancelled');
            }
          }
          if (view.name === 'basicDay') {
            eventContainer = $(element).find('.fc-event-inner');
            titleClassname = $scope.showCapacity ? 'fc-event-title' : 'fc-event-title fc-event-title--without-capacity';
            if (event.isCancelled) {
              titleClassname += ' fc-event-title--cancelled';
            }
            typeInstructorClassname = $scope.showInstructor ? '' : 'event-type--without-instructor';
            typeEmptyClassname = event.event_type_names ? '' : 'event-type--empty';
            typeCancelledClassname = event.isCancelled ? 'fc-agenda-item--cancelled' : '';
            typeClassname = `event-type ${typeInstructorClassname} ${typeEmptyClassname} ${typeCancelledClassname}`;
            classroomInstructorClassname = $scope.showInstructor ? '' : 'event-classroom--without-instructor';
            classroomDividerClassname = event.event_type_names ? '' : 'event-classroom--hide-divider';
            classroomCancelledClassname = event.isCancelled ? 'fc-agenda-item--cancelled' : '';
            classroomClassname = `event-classroom ${classroomInstructorClassname} ${classroomDividerClassname} ${classroomCancelledClassname}`;
            instructorCancelledClassname = event.isCancelled ? 'event-instructor--cancelled' : '';
            vacanciesCancelledClassname = event.isCancelled ? 'event-vacancies--cancelled' : '';
            if ($scope.showInstructor) {
              'event-classroom';
            } else {
              'event-classroom event-classroom--without-instructor';
            }
            if ($scope.showCapacity) {
              eventContainer.append(`<span class='event-vacancies ${vacanciesCancelledClassname}'>` + (!event.old_event && event.vacancies_count || '-') + '</span>');
            } else {
              eventContainer.find('.fc-event-title').addClass('fc-event-title--without-capacity');
            }
            if ($scope.showInstructor) {
              eventContainer.append(`<span class='fc-agenda-item event-instructor ${instructorCancelledClassname}'>${event.instructor_names}</span>`);
            }
            eventContainer.append(`<span class='fc-agenda-item ${typeClassname}'>${event.event_type_names || ''}</span>`);
            eventContainer.append(`<span class='fc-agenda-item ${classroomClassname}'>${event.classroom_name}</span>`);
            if (event.isCancelled) {
              eventTitleElement = $(element).find('.fc-event-title');
              if (eventTitleElement.length) {
                if (event.isTitleLong) {
                  eventTitleElement.css({
                    'white-space': 'nowrap',
                    'overflow': 'hidden',
                    'text-overflow': 'ellipsis'
                  });
                } else {
                  titleText = eventTitleElement.text();
                  eventTitleElement.empty();
                  eventTitleElement.append($('<span>').css('text-decoration', 'line-through').text(titleText));
                  eventTitleElement.append(' ');
                  eventTitleElement.append($('<span>').addClass('fc-event__cancelled-badge').text('CANCELLED'));
                }
              }
              $(element).find('.fc-event-time').addClass('fc-event-time--cancelled');
            }
            instructorCell = $scope.showInstructor ? '<span class="fc-agenda-item event-instructor">Instructor</span>' : '';
            capacityCell = $scope.showCapacity ? '<span class="event-space">Places Left</span>' : '';
            headerTitleClassname = $scope.showCapacity ? 'fc-event-title' : 'fc-event-title fc-event-title--without-capacity';
            typeHeaderClassname = $scope.showInstructor ? 'event-type' : 'event-type event-type--without-instructor';
            classroomHeaderClassname = $scope.showInstructor ? 'event-classroom' : 'event-classroom event-classroom--without-instructor';
            eventsHeader = `<div class="fc-agenda-head fc-event-hori">
  <span class="fc-event-time">Time</span>
  <span class="${headerTitleClassname}">Class</span>
  ${capacityCell}
  ${instructorCell}
  <span class="fc-agenda-item ${typeHeaderClassname}">Type</span>
  <span class="fc-agenda-item ${classroomHeaderClassname}">Location</span>
</div>`;
            return $('.fc-day-header').html(eventsHeader);
          }
        }
      }
    };
  });
}]);
